module.exports = __webpack_public_path__ + "static/media/FichaTecnica-SoftwoneERP.c4716dbc.pdf";